import * as s from "../../LoginStyled";
import { Text, UnderlineText } from "components/atoms/text/Text";
import { Validate, ValidateMsg } from "api/interfaces/commonInterface.interface";
import {
  LOGIN_STEP,
  LoginInfo,
} from "../../LoginContainer";
import { COLORS } from "styles/colors";
import InputEmailForm from "./InputEmailForm";

interface Props {
  loginInfo: LoginInfo;
  isValidated: Validate;
  validateMsg: ValidateMsg;
  onChangeLoginInfo: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeRemember: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checkedRemember: boolean;
  onChangeStep: (step: LOGIN_STEP) => void;
  handleClick: () => void;
  disabled: boolean;
}
export default function InputEmail({
  loginInfo,
  isValidated,
  validateMsg,
  onChangeLoginInfo,
  onChangeRemember,
  checkedRemember,
  onChangeStep,
  handleClick,
}: Props) {
  return (
    <s.LoginInputEmailWrapper>
      <InputEmailForm
        loginInfo={loginInfo}
        isValidated={isValidated}
        validateMsg={validateMsg}
        onChangeLoginInfo={onChangeLoginInfo}
        handleClick={handleClick}
      />

      <s.Bottom>
        <label>
          <input
            id="dw_login_input_checkedRemember"
            type="checkbox"
            checked={checkedRemember}
            onChange={onChangeRemember}
            data-testid="auth-signin-email-input-checked-remember-change-remember"
          />

          <Text fontSize={14}>Remember Email</Text>
        </label>
        <UnderlineText
          id="dw_login_button_forward_forgotEmail"
          fontSize={14}
          color={COLORS.BUTTONS2}
          onClick={() => onChangeStep(LOGIN_STEP.FORGOT_EMAIL)}
          data-testid="auth-signin-email-forward-forgot-email-change-step"
        >
          Forgot Email?
        </UnderlineText>
      </s.Bottom>
    </s.LoginInputEmailWrapper>
  );
}
